module.exports = __webpack_public_path__ + "img/home.584a8b1f.svg";